import React from 'react'
import Icon from 'antd/lib/icon'

const getType = (id) => {
    switch (id) {
        case 'addResources':
            return 'exclamation-circle'
        case 'assistance':
            return 'contacts'
        case 'bars':
            return 'bars'
        case 'library':
            return 'global'
        case 'book':
            return 'book'
        case 'building':
            return 'home'
        case 'calendar':
            return 'calendar'
        case 'client':
            return 'dollar'
        case 'covid':
            return 'deployment-unit'
        case 'dashboard':
            return 'dashboard'
        case 'documents':
            return 'file-pdf'
        case 'floorWarden':
            return 'safety'
        case 'floorPlan':
            return 'picture'
        case 'procedures':
            return 'read'
        case 'property':
            return 'home'
        case 'manage':
            return 'tool'
        case 'map':
            return 'environment'
        case 'news':
            return 'wifi'
        case 'notifications':
            return 'mail'
        case 'quiz':
            return 'safety-certificate'
        case 'report':
            return 'line-chart'
        case 'resources':
            return 'folder'
        case 'settings':
            return 'setting'
        case 'support':
            return 'customer-service'
        case 'teams':
            return 'team'
        case 'training':
            return 'play-square'
        case 'user':
            return 'user'
        case 'video':
            return 'play-circle'
        default:
            return null
    }
}

const MenuIcons = ({ id, color, externalIcon }) => {
    if (externalIcon) {
        return <img src={id} width="14px" height="14px" style={{ marginRight: '10px' }} />
    }

    return <Icon theme="outlined" type={getType(id)} />
}

export default MenuIcons
